import classNames from "classnames";
import React from "react";
import * as Ons from "react-onsenui";
import { CASE_SETTINGS_SVG } from "../utils/svgs";
import { MY_LOCATION_ICON, WARNING_TRIANGLE_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";

interface AvailableVisitsMapFabsProps {
  filtersFabOptions?: {
    isFiltersSecionOpen: boolean;
    onClick: () => void;
  };
  medflytComplianceAlertFabOptions?: {
    showMedflytComplianceAlert: boolean;
    onClick: () => void;
  };
  currentPositionFabOptions?: {
    onClick: () => void;
  };
  homeFabOptions?: {
    onClick: () => void;
  };
  caseSettingsFabOptions?: {
    onClick: () => void;
  };
}

const MapFabs = (props: AvailableVisitsMapFabsProps) => {
  return (
    <div
      className={classNames({
        AvailableVisitsLiveMap__fabButtons: true,
        OnFilterOpen:
          props.filtersFabOptions !== undefined && props.filtersFabOptions.isFiltersSecionOpen,
      })}
    >
      {props.medflytComplianceAlertFabOptions !== undefined &&
      props.medflytComplianceAlertFabOptions.showMedflytComplianceAlert ? (
        <Ons.Fab
          className={classNames({
            AvailableVisitsLiveMap__fabButton: true,
            AvailableVisitsLiveMap__medflytComplianceWarningFab: true,
            AvailableVisitsLiveMap__homeFabButton: true,
            AvailableVisitsLiveMap__currLocationFabButton: true,
          })}
          modifier="mini"
          position="bottom right"
          onClick={props.medflytComplianceAlertFabOptions.onClick}
        >
          <AppIcon icon={WARNING_TRIANGLE_ICON} />
        </Ons.Fab>
      ) : null}
      {props.caseSettingsFabOptions !== undefined ? (
        <Ons.Fab
          className={classNames({
            AvailableVisitsLiveMap__fabButton: true,
            AvailableVisitsLiveMap__caseSettingsFab: true,
          })}
          modifier="mini"
          position="bottom right"
          onClick={props.caseSettingsFabOptions.onClick}
        >
          <AppIcon icon={CASE_SETTINGS_SVG} />
        </Ons.Fab>
      ) : null}
      {props.currentPositionFabOptions !== undefined ? (
        <Ons.Fab
          className={classNames({
            AvailableVisitsLiveMap__fabButton: true,
            AvailableVisitsLiveMap__homeFabButton: true,
            AvailableVisitsLiveMap__currLocationFabButton: true,
          })}
          modifier="mini"
          position="bottom right"
          onClick={props.currentPositionFabOptions.onClick}
        >
          <AppIcon icon={MY_LOCATION_ICON} />
        </Ons.Fab>
      ) : null}
      {props.homeFabOptions !== undefined ? (
        <Ons.Fab
          className={classNames({
            AvailableVisitsLiveMap__fabButton: true,
            AvailableVisitsLiveMap__homeFabButton: true,
          })}
          modifier="mini"
          position="bottom right"
          onClick={props.homeFabOptions.onClick}
        >
          <img height="23" width="23" src="assets/home.svg" />
        </Ons.Fab>
      ) : null}
      {props.filtersFabOptions !== undefined ? (
        <Ons.Fab
          className={classNames({
            AvailableVisitsLiveMap__fabButton: true,
            AvailableVisitsLiveMap__filterFabButton: true,
          })}
          modifier="mini"
          position="bottom right"
          onClick={props.filtersFabOptions.onClick}
        >
          <img height="23" width="23" src="assets/filter.svg" />
        </Ons.Fab>
      ) : null}
    </div>
  );
};

export default MapFabs;
